module.exports = __webpack_public_path__ + "img/6.2b7c5d5e.jpg";